// src/components/SubscriptionCard.js
import React from 'react';
import { Sparkles, CalendarX2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

function SubscriptionCard({ subscription }) {
    const navigate = useNavigate();

    // 👇 NEW: Helper function to convert YYYY-MM-DD to DD/MM/YYYY
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const parts = dateString.split('-');
        if (parts.length !== 3) return dateString;
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
    };

    if (!subscription) {
        return (
            <div className="bg-[#971253]/5 border border-[#971253]/10 rounded-2xl p-8 flex flex-col items-center text-center relative overflow-hidden">
                <div className="w-16 h-16 bg-[#971253]/10 rounded-full flex items-center justify-center mb-4">
                    <Sparkles size={28} className="text-[#971253]" />
                </div>
                <h3 className="font-serif text-xl text-[#971253] mb-2">Desbloqueie o Acervo</h3>
                <p className="text-stone-500 font-light text-sm max-w-sm mb-6">
                    Assinantes não pagam passaporte, têm prioridade em reservas e acesso ilimitado aos jogos.
                </p>
                <button 
                    onClick={() => navigate('/assinatura')}
                    className="px-8 py-3 bg-[#971253] text-[#FFF5EE] rounded-xl font-bold uppercase tracking-widest text-sm hover:bg-[#7a0e42] transition-colors shadow-lg hover:-translate-y-1"
                >
                    Assinar Agora
                </button>
            </div>
        );
    }

    return (
        <div className="relative bg-white border border-[#dbcdac]/50 rounded-2xl p-6 md:p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 shadow-sm overflow-hidden">
            {/* Detalhe visual na borda esquerda */}
            <div className="absolute left-0 top-0 bottom-0 w-2 bg-[#971253]"></div>
            
            <div className="pl-4">
                <div className="flex items-center gap-3 mb-2">
                    <h3 className="font-serif text-2xl font-bold text-stone-800">{subscription.planName}</h3>
                    <span className={`px-3 py-1 text-[10px] font-bold uppercase tracking-widest rounded-full ${subscription.active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                        {subscription.active ? 'Ativa' : 'Expirada'}
                    </span>
                </div>
                <p className="text-stone-500 flex items-center gap-2 text-sm">
                    <CalendarX2 size={16} className="text-[#dbcdac]" />
                    {/* 👇 UPDATED: Applied the formatter here */}
                    Válida até {formatDate(subscription.endDate)}
                </p>
            </div>
        </div>
    );
}

export default SubscriptionCard;